import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { CancelType } from "@/types/order/CancelRequest";

// localStorage に保存されたデータを利用する
const ls = localStorage.getItem("vuex");
const cancelRequest = ls !== null ? JSON.parse(ls).cancelRequest : undefined;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "cancelRequest",
  preserveState: cancelRequest !== undefined
})
class CancelRequestModule extends VuexModule {
  phoneCallApplicationId: number | null = null;
  cancelType: CancelType | null = null;

  @Mutation
  private SET_PHONE_CALL_APPLICATION_ID(id: number | null) {
    this.phoneCallApplicationId = id;
  }

  @Action
  setPhoneCallApplicationId(id: number) {
    this.SET_PHONE_CALL_APPLICATION_ID(id);
  }

  @Action
  clearPhoneCallApplicationId() {
    this.SET_PHONE_CALL_APPLICATION_ID(null);
  }

  @Mutation
  private SET_CANCEL_TYPE(cancelType: CancelType | null) {
    this.cancelType = cancelType;
  }

  @Action
  setCancelType(cancelType: CancelType | null) {
    this.SET_CANCEL_TYPE(cancelType);
  }

  @Action
  clearCancelType() {
    this.SET_CANCEL_TYPE(null);
  }
}

export const cancelRequestStore = getModule(CancelRequestModule);
